module.exports = __webpack_public_path__ + "static/media/rupay.43dfe714.png";